var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Row, Col, Accordion, Button } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { Controller, } from "react-hook-form";
import { RecekTextField, RecekSelect } from "./inputs";
import { PersonIdentifierTypeEnum } from "../types/Api";
export var LegalPersonIdentifierFields = function (_a) {
    var control = _a.control, errors = _a.errors, identifierFields = _a.identifierFields, onAddIdentifier = _a.onAddIdentifier, onRemoveIdentifier = _a.onRemoveIdentifier;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(Accordion, { label: formatMessage({
            id: "ui-br-agency.natural-person.accordions.label.identifiers",
        }), separator: false },
        identifierFields.map(function (field, index) { return (React.createElement(Row, { key: field.id },
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "identifiers.".concat(index, ".type"), render: function (_a) {
                        var _b, _c, _d;
                        var field = _a.field;
                        return (React.createElement(RecekSelect, __assign({}, field, { labelId: "ui-br-agency.natural-person.identifier.type.field.label", error: 
                            // The field is named "type", which collides with FieldError["type"].
                            (_d = (_c = (_b = errors.identifiers) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.type) === null || _d === void 0 ? void 0 : _d.message, required: true }),
                            React.createElement("option", { value: "" }, formatMessage({
                                id: "ui-br-agency.natural-person.identifierType.select.placeholder",
                            })),
                            React.createElement("option", { value: PersonIdentifierTypeEnum.ISNI }, formatMessage({
                                id: "ui-br-agency.natural-person.identifier.type.isni",
                            })),
                            React.createElement("option", { value: PersonIdentifierTypeEnum.ORCID }, formatMessage({
                                id: "ui-br-agency.natural-person.identifier.type.orcid",
                            }))));
                    } })),
            React.createElement(Col, { xs: 6 },
                React.createElement(Controller, { control: control, name: "identifiers.".concat(index, ".identifier"), render: function (_a) {
                        var _b, _c, _d;
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.natural-person.identifier.value.field.label", error: (_d = (_c = (_b = errors.identifiers) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.identifier) === null || _d === void 0 ? void 0 : _d.message, required: true })));
                    } })),
            React.createElement(Col, { xs: 2 },
                React.createElement(Button, { buttonStyle: "danger", onClick: function () { return onRemoveIdentifier(index); }, style: { marginTop: "1.5rem" } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.remove" }))))); }),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Button, { buttonStyle: "default", onClick: onAddIdentifier },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.natural-person.button.addIdentifier" }))))));
};
